import { Component, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmployeeResource } from '../../../model/api/administration/employee-resource';
import { EmployeeRoom } from '../../../model/api/administration/employee-room';
import { Room } from '../../../model/api/administration/room';
import { CodeNameEntity } from '../../../model/api/common/code-name-entity';
import { GenericDetail } from '../../generic/generic.detail';

@Component({
    selector: 'employee-room-detail',
    templateUrl: 'employee-room.detail.html',
    outputs: ['employeeNeeded', 'roomNeeded']
})
export class EmployeeRoomDetail extends GenericDetail<EmployeeRoom, number> {

    @ViewChild('detailForm') detailForm: FormGroup;

    public roomNeeded: EventEmitter<void> = new EventEmitter<void>();
    public employeeNeeded: EventEmitter<void> = new EventEmitter<void>();

    public selectedRoom: CodeNameEntity = null;
    public selectedEmployee: EmployeeResource = null;

    setItemDefaultValues() {
        this.item = new EmployeeRoom(0, null, null);
    }

    public resetForm() {
        this.detailForm.reset();
    }

    public saveItem() {
      super.saveItem();
    }

    public set room(room: Room) {
        this.selectedRoom = room;
        this.item.room = room != null ? new CodeNameEntity(room.id, room.code, room.name) : null;
    }

    public askForRoom() {
        this.roomNeeded.emit();
    }

    public set employee(employee: EmployeeResource) {
        this.selectedEmployee = employee;
        this.item.employee = employee != null ? new EmployeeResource(employee.id, employee.internalCode, employee.firstName, employee.lastName) : null;
    }

    public askForEmployee() {
        this.employeeNeeded.emit();
    }
}
